import { createApp } from 'vue'
import StafetDeltagPaaHoldStepTwo from './StafetDeltagPaaHoldStepTwo'

const el = '.kb-component--stafet-join-a-team-step-two'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetDeltagPaaHoldStepTwoDOM) => {
            const component = createApp(StafetDeltagPaaHoldStepTwo).use(Store)
            component.mount(StafetDeltagPaaHoldStepTwoDOM)
        })
    }
}
